/**
 * A positive whole number of seconds from a `retry_after` body field or a
 * `Retry-After` header value, or undefined when it carries no usable delay.
 * Only the delta-seconds form is read: the api never sends an HTTP-date.
 */
export const retryAfterSeconds = (value: unknown): number | undefined => {
  const n = typeof value === "string" ? parseInt(value, 10) : value;
  return typeof n === "number" && isFinite(n) && n > 0 ? Math.ceil(n) : undefined;
};
